export default {
  title: 'NOL | 놀수록 놀라운 세상',
  additionalMetaTags: [
    {
      name: 'google',
      content: 'notranslate',
    },
    {
      name: 'keywords',
      content: '놀, nol, 야놀자, yanolja',
    },
  ],
  openGraph: {
    title: 'NOL | 놀수록 놀라운 세상',
    images: [{ url: 'https://yaimg.yanolja.com/joy/sunny/static/images/nol/nol_og_1200x600.png' }],
  },
}
